module.exports = __webpack_public_path__ + "img/pindan.6c8aed34.png";